<template>
  <div class="popup">
    <div class="popup_main">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          prop="campaign_name"
          label="选项"
          width="100"
        ><template slot-scope="scope">
          <span class="option" :class="{active:item && (item.id === scope.row.id)}" @click="handleOption(scope.row)" />
        </template>
        </el-table-column>
        <el-table-column
          prop="campaign_name"
          label="名称"
          width="180"
        />
        <el-table-column
          prop="id"
          label="id"
          width="180"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
        >
          <template slot-scope="scope">
            <span>{{ interceptionTime(scope.row.created_at) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="main_paging">
        <el-pagination
          layout="prev, pager, next"
          :total="tatol"
          @current-change="(page = $event),(getList())"
        />
      </div>

    </div>
    <div
      class="popup_button"
      style="display: flex;
    justify-content: flex-end;"
    >
      <el-button type="primary" @click="getUp">尼玛创建计划</el-button>
    </div>
  </div>
</template>

<script>
import { getPublicplan } from '@/api/publicPlan.js'
export default {
  name: 'CreateAdvertiserDirectionPackage',
  components: {
  },
  data() {
    return {
      tableData: [],
      tatol: null,
      loading: false,
      page: 1,
      item: null
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      const data = await getPublicplan({
        page: this.page
      })
      this.loading = false
      this.tableData = data.data.list
      this.tatol = data.data.count
    },
    interceptionTime(time) {
      if (!time) {
        return
      }
      const index = time.indexOf('T')
      return time.slice(0, index)
    },
    handleOption(item) {
      if (this.item && (this.item.id === item.id)) {
        this.item = null
      } else {
        this.item = item
      }
    },
    async getUp() {
      if (!this.item) {
        this.$message({
          message: '选选择公共项',
          type: 'warning'
        })
        return
      }

      this.$emit('create', this.item)
    }
  }
}
</script>

<style lang="less" scoped>
.popup{
  .popup_main{
    .main_paging{
      display: flex;
      justify-content: flex-end;
    }

    .option{
       display: inline-block;
       width: 13px;
       height: 13px;
       box-shadow: 0px 0px 0px 1px #ccc;
       border-radius: 2px;
       cursor: pointer;
       &:not(.active):hover{
         box-shadow: 0px 0px 3px 1px #ccc;
       }

       &.active{
         background-color: #abcdef;
       }
    }
  }
}
</style>
